import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import moment from "moment";

const images = [
  "a",
  "ab",
  "ac",
  "ad",
  "b",
  "bird2",
  "c",
  "coffee",
  "cup",
  "flower",
  "gloves",
  "hat",
  "hat2",
  "merry",
  "shirt",
  "snowflake",
  "snowman",
  "tree",
  "tree2",
  "tree3"
];

const MathType = {
  ADDITION: 1,
  SUBTRACTION: 2,
  MULTIPLICATION: 3,
  DIVISION: 4
};

const GameState = {
  MENU: 1,
  PLAYING: 2,
  FINISHED: 3
};

const Finish = ({ gameStart, finish }) => (
  <div className="finish">
    <h1>Finish</h1>
    <p>You finished in {finish.diff(gameStart, "seconds")} seconds</p>
  </div>
);

class Menu extends Component {
  render() {
    return (
      <div className="App">
        <div className="menu">
          <div className="menu-container">
            <h1>Advent Calendar Multiplication</h1>
            <div className="options">
              <div
                onClick={() => this.props.changeOption("numberOfPlayers", 1)}
                className={`option ${this.props.options.numberOfPlayers === 1
                  ? ""
                  : ""}`}
              >
                <input
                  type="radio"
                  checked={this.props.options.numberOfPlayers === 1}
                />
                1 Player
              </div>
              <div
                onClick={() => this.props.changeOption("numberOfPlayers", 2)}
                className={`option ${this.props.options.numberOfPlayers === 2
                  ? ""
                  : ""}`}
              >
                <input
                  type="radio"
                  checked={this.props.options.numberOfPlayers === 2}
                />
                2 Players
              </div>
            </div>
            <button onClick={this.props.startGame}>Start Game</button>
          </div>
        </div>
      </div>
    );
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameState: GameState.MENU,
      gameStart: null,
      options: {
        numberOfPlayers: 2
      },
      players: [
        {
          finish: null,
          answered: [],
          answers: [],
          currentQuestion: { ...this.generateQuestion() }
        },
        {
          finish: null,
          answered: [],
          answers: [],
          currentQuestion: { ...this.generateQuestion() }
        }
      ]
    };
  }

  startGame = () => {
    const answers = this.generateAnswers(
      [],
      0,
      this.state.players[0].currentQuestion.a *
        this.state.players[0].currentQuestion.b
    );
    const answers2 = this.generateAnswers(
      [],
      0,
      this.state.players[1].currentQuestion.a *
        this.state.players[1].currentQuestion.b
    );
    const player1 = this.state.players[0];
    player1.answers = [...answers];
    const player2 = this.state.players[1];
    player2.answers = [...answers2];
    this.setState({
      players: [player1, player2],
      gameState: GameState.PLAYING,
      gameStart: moment()
    });
  };

  generateQuestion = () => {
    return {
      a: Math.floor(Math.random() * 10 + 2),
      b: Math.floor(Math.random() * 10 + 2),
      type: MathType.ADDITION
    };
  };

  handleClick = (player, answer, index) => e => {
    e.preventDefault();
    const { players } = this.state;
    const { currentQuestion, answered } = players[player];
    const correctAnswer = currentQuestion.a * currentQuestion.b;
    if (answer == correctAnswer) {
      const answered2 = [...answered];
      answered2.push(index);
      const numberOfCorrectAnswer =
        window.location.href.toLowerCase().indexOf("preview") >= 0 ? 3 : 20;
      if (answered2.length === numberOfCorrectAnswer) {
        const players = [...this.state.players];
        players[player] = {
          ...this.state.players[player],
          finish: moment()
        };
        this.setState({
          players: [...players]
        });
        return;
      }
      const question = this.generateQuestion();
      const answers = this.generateAnswers(
        answered2,
        player,
        question.a * question.b
      );
      const players = [...this.state.players];
      players[player] = {
        ...this.state.players[player],
        answered: answered2,
        answers,
        currentQuestion: question
      };
      this.setState({
        players: [...players]
      });
    }
  };

  generateAnswers = (answered, player, correctAnswer) => {
    const answers = [];
    for (var i = 0; i < 20; i++) {
      answers.push(Math.floor(Math.random() * 50 + 1));
    }
    let inserted = false;
    while (inserted === false) {
      const index = Math.floor(Math.random() * 20);
      if (answered.indexOf(index) < 0) {
        inserted = true;
        answers[index] = correctAnswer;
      }
    }
    return answers;
  };

  render() {
    if (this.state.gameState === GameState.MENU) {
      return (
        <Menu
          startGame={this.startGame}
          options={this.state.options}
          changeOption={(option, value) =>
            this.setState({ options: { [option]: value } })}
        />
      );
    }
    return (
      <div
        className={`App ${this.state.options.numberOfPlayers === 2
          ? "two-players"
          : "one-player"}`}
      >
        {(this.state.players[0].finish !== null &&
          this.state.players[1].finish !== null) ||
        (this.state.players[0].finish !== null &&
          this.state.options.numberOfPlayers === 1) ? (
          <div className="finish-container">
            <button onClick={() => window.location.reload()}>
              Restart Game
            </button>
          </div>
        ) : null}
        <div className="player">
          <div className="answers-container">
            {this.state.players[0].finish !== null ? (
              <Finish
                {...this.state.players[0]}
                gameStart={this.state.gameStart}
              />
            ) : (
              <div className="answers">
                {images.map(
                  (i, index) =>
                    this.state.players[0].answered.indexOf(index) >= 0 ? (
                      <div key={index} className="answer open">
                        <img src={i + ".svg"} />
                      </div>
                    ) : (
                      <div
                        key={index}
                        className="answer"
                        onClick={this.handleClick(
                          0,
                          this.state.players[0].answers[index],
                          index
                        )}
                      >
                        <span>{this.state.players[0].answers[index]}</span>
                      </div>
                    )
                )}
              </div>
            )}
          </div>
          <div className="question">
            {this.state.players[0].currentQuestion.a} x {" "}
            {this.state.players[0].currentQuestion.b}
          </div>
        </div>
        {this.state.options.numberOfPlayers === 2 && (
          <div className="player">
            <div className="answers-container">
              {this.state.players[1].finish !== null ? (
                <Finish
                  {...this.state.players[1]}
                  gameStart={this.state.gameStart}
                />
              ) : (
                <div className="answers">
                  {images.map(
                    (i, index) =>
                      this.state.players[1].answered.indexOf(index) >= 0 ? (
                        <div key={index} className="answer open">
                          <img src={i + ".svg"} />
                        </div>
                      ) : (
                        <div
                          key={index}
                          className="answer"
                          onClick={this.handleClick(
                            1,
                            this.state.players[1].answers[index],
                            index
                          )}
                        >
                          <span>{this.state.players[1].answers[index]}</span>
                        </div>
                      )
                  )}
                </div>
              )}
            </div>
            <div className="question">
              {this.state.players[1].currentQuestion.a} x{" "}
              {this.state.players[1].currentQuestion.b}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js